import React from "react";
import { withRouter } from "react-router-dom";
import {
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput
} from "shards-react";

import { openSecretPage } from "./../../../utils/secretSearch";

const NavbarSearch = ({ history }) => (
  <Form
    className="main-navbar__search w-100 d-none d-md-flex d-lg-flex"
    onSubmit={event => event.preventDefault()}
  >
    <InputGroup seamless className="ml-3">
      <InputGroupAddon type="prepend">
        <InputGroupText>
          <i className="material-icons">search</i>
        </InputGroupText>
      </InputGroupAddon>
      <FormInput
        className="navbar-search"
        placeholder="Vyhledat..."
        onChange={event => openSecretPage(event.target.value, history)}
      />
    </InputGroup>
  </Form>
);

export default withRouter(NavbarSearch);
